<template>
  <div class="overlay-container">
    <div v-if="show" class="custom-overlay">
      <div class="overlay-spinner" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Overlay",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.overlay-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: block;
  box-sizing: border-box;
  overflow: hidden auto;
}

.custom-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  z-index: 1000;
}

.overlay-spinner {
  width: 2rem;
  height: 2rem;
  border: 0.25rem solid rgba(0, 155, 76, 0.1);
  border-top-color: #020f40;
  border-radius: 50%;
  animation: overlay-spin 1s linear infinite;
}

/* small modifier: use when you need a smaller spinner */
.overlay-small .overlay-spinner,
.overlay-spinner.overlay-small {
  width: 1.2rem;
  height: 1.2rem;
}

@keyframes overlay-spin {
  to {
    transform: rotate(360deg);
  }
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>